<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageSmartpricingSettings.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageSmartpricingSettings.card.general')" cols="12 6@desktop" rows="1">
        <hm-input-toggle id="enabled"
                         v-model="config.enabled"
                         :label="$t('admin.interfaces.pageSmartpricingSettings.enabled')"
                         :enabled-title="$t('enabled')"
                         :disabled-title="$t('disabled')"
                         :disabled="!canEnable" />
        <hm-input-toggle id="retrievePrices"
                         v-model="config.retrievePrices"
                         :disabled="!config.enabled || !hasRole('ROLE_SYSADMIN')"
                         :label="$t('admin.interfaces.pageSmartpricingSettings.retrievePrices')"
                         :enabled-title="$t('admin.interfaces.pageSmartpricingSettings.retrievePrices_enabled')"
                         :disabled-title="$t('admin.interfaces.pageSmartpricingSettings.retrievePrices_disabled')"/>
        <hm-input id="hotelId" v-model="config.hotelId" :label="$t('admin.interfaces.pageSmartpricingSettings.hotelId')" />
        <hm-input-toggle id="historicReservationsSent" :value="config.historicReservationsSent" :label="$t('admin.interfaces.pageSmartpricingSettings.historicReservationsSent')" disabled />
      </card>

      <card :title="$t('admin.interfaces.pageSmartpricingSettings.card.priceImport')" cols="12" rows="1" min-height="600px">
        <dynamic-table-editor v-model="config.ratePlanMapping"
                              :auto-extend="true"
                              :empty-record="{
                                ratePlanId: null,
                                rateId: 'SP_RATE',
                                occupancyLevel: 'DefaultOccupancy',
                                deleteOtherOccupancyPrices: true,
                                retrievePrices: true,
                              }"
                              :table-headings="[$t('admin.interfaces.pageSmartpricingSettings.ratePlan'), $t('admin.interfaces.pageSmartpricingSettings.smartPricingRateId'), $t('admin.interfaces.pageSmartpricingSettings.occupancy'), $t('admin.interfaces.pageSmartpricingSettings.clearOtherOccupancyPrices'), $t('admin.interfaces.pageSmartpricingSettings.importPricesForMapping')]"
                              :not-valued="(it) => isEmpty(it.ratePlanId)"
                              :label="$t('admin.interfaces.pageSmartpricingSettings.card.priceImport')"
                              min-width="1024px">
          <template v-slot:default="props">
            <div class="hm-table__td">
              <hm-input-select :inline="true"
                               :id="`ratePlanId-${props.valueIdx}`"
                               v-model="props.value.ratePlanId"
                               :label="$t('admin.interfaces.pageSmartpricingSettings.ratePlan')"
                               name="ratePlanId">
                <option v-for="item in hotelSettings.ratePlans.all(props.value.ratePlanId)"
                        :disabled="item.rateEntryMode !== 'Daily' || (!isEmpty(item.parentRatePlanId) && !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN'))"
                        :value="item.id"
                        v-html="item.name[$shortLocale]" />
              </hm-input-select>
            </div>
            <div class="hm-table__td">
              <hm-input :inline="true"
                        :id="`rateId-${props.valueIdx}`"
                        v-model="props.value.rateId"
                        :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                        :label="$t('admin.interfaces.pageSmartpricingSettings.smartPricingRateId')"
                        name="rateId" />
            </div>
            <div class="hm-table__td">
              <hm-input-select :inline="true"
                               :id="`occupancyLevel-${props.valueIdx}`"
                               v-model="props.value.occupancyLevel"
                               :label="$t('admin.interfaces.pageSmartpricingSettings.occupancy')"
                               enum-name="SmartpricingOccupancy"
                               name="occupancyLevel" />
            </div>
            <div class="hm-table__td">
              <hm-input-checkbox :inline="true"
                                 :id="`deleteOtherOccupancyPrices-${props.valueIdx}`"
                                 v-model="props.value.deleteOtherOccupancyPrices"
                                 :label="$t('admin.interfaces.pageSmartpricingSettings.clearOtherOccupancyPrices')"
                                 name="deleteOtherOccupancyPrices" />
            </div>
            <div class="hm-table__td">
              <hm-input-checkbox :inline="true"
                                 :id="`retrievePrices-${props.valueIdx}`"
                                 v-model="props.value.retrievePrices"
                                 :label="$t('admin.interfaces.pageSmartpricingSettings.importPricesForMapping')"
                                 name="retrievePrices" />
            </div>
          </template>
        </dynamic-table-editor>
      </card>


      <hm-floating-buttons v-if="!isNil(config)">
        <!--        <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"-->
        <!--                            :label="$t('admin.interfaces.pageSmartpricingSettings.resetReservations')"-->
        <!--                            color="orange"-->
        <!--                            icon="refresh"-->
        <!--                            @click="resetReservations()" />-->
        <!--        <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"-->
        <!--                            :label="$t('admin.interfaces.pageSmartpricingSettings.resetPrices')"-->
        <!--                            color="orange"-->
        <!--                            icon="refresh"-->
        <!--                            @click="resetPrices()" />-->
        <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') || (hasRole('ROLE_ADMIN') && !config.historicReservationsSent)"
                            :label="$t('admin.interfaces.pageSmartpricingSettings.sendHistoricReservations')"
                            color="orange"
                            icon="upload"
                            @click="sendHistoricReservations()" />
        <hm-floating-button v-if="hasRole('ROLE_SYSADMIN')"
                            :label="$t('admin.interfaces.pageSmartpricingSettings.retrievePrices')"
                            color="orange"
                            icon="download"
                            @click="retrievePrices()" />
      </hm-floating-buttons>
  </template></main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, find, findIndex, isEmpty, isNil, keyBy, max, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import HmTextarea from '../../../lib/inputs/HmTextarea.vue';
import AiTextGenerator from '../../../lib/util/AiTextGenerator.vue';
import uuid from 'uuid';
import HmFloatingButton from '../../../lib/inputs/HmFloatingButton.vue';
import HmFloatingChildButton from '../../../lib/inputs/HmFloatingChildButton.vue';
import HmInputToggle from '../../../lib/inputs/HmInputToggle.vue';
import HmInputNumber from '../../../lib/inputs/HmInputNumber.vue';
import HmInput from '../../../lib/inputs/HmInput.vue';
import HmButton from '../../../lib/buttons/HmButton.vue';
import TabableCard from '../../../lib/layout/TabableCard.vue';
import HmCol from '../../../lib/layout/HmCol.vue';
import DynamicTableEditor from '../../../lib/inputgroups/DynamicTableEditor.vue';
import HmMultiselect from '../../../lib/inputs/HmMultiselect.vue';

export default {
  name: 'PageSmartpricingSettings',
  components: {
    HmMultiselect,
    DynamicTableEditor,
    HmCol,
    TabableCard,
    HmButton,
    HmInput,
    HmInputNumber,
    HmInputToggle,
    HmFloatingChildButton,
    HmFloatingButton,
    AiTextGenerator,
    HmTextarea,
    HmInputSelect,
    HmCardInner,
    HmInputMoney,
    HmInputCheckbox,
    Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, UpdateHotelSettingsMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const config = cloneDeep(this.config);

        config.ratePlanMapping = config.ratePlanMapping.filter(it => !isEmpty(it.ratePlanId) && !isEmpty(it.rateId));

        this.axios.put(this.serviceUrls.interfaces.smartpricing.get(this, config.id), config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    roomMap: function () {
      return keyBy(this.hotelSettings.rooms, 'roomNumber');
    },
    canEnable() {
      return true;
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.smartpricing.list(this))
        .then((response) => {
          this.config = response.data.data;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    sendHistoricReservations() {
      this.axios.post(this.serviceUrls.interfaces.smartpricing.sendHistoricReservations(this, this.config.id))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    retrievePrices() {
      this.axios.post(this.serviceUrls.interfaces.smartpricing.retrievePrices(this, this.config.id))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    resetPrices() {
      this.axios.post(this.serviceUrls.interfaces.smartpricing.resetPrices(this, this.config.id))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    resetReservations() {
      this.axios.post(this.serviceUrls.interfaces.smartpricing.resetReservations(this, this.config.id))
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageSmartpricing.vue